import i18next from 'i18next';

export function resolveErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  return typeof error === 'string' ? error : i18next.t('generic.unknownError');
}
